// Resolve the notice handler when called: it can initialize after this module.
export const showNotice = (type: 'alert' | 'notice', message: string): void =>
  (window as any).showNotice(type, message)

export const presentNotice = (message: string) => showNotice('notice', message)
export const presentAlert = (message: string) => showNotice('alert', message)
